import { useEffect, useState } from "react";

import {
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  format,
  isToday,
} from "date-fns";

interface RelativeTimeProps {
  date: Date;
  className?: string;
}

export function RelativeTime({ date, className }: RelativeTimeProps) {
  const [formattedTime, setFormattedTime] = useState<string>("");

  useEffect(() => {
    const formatRelativeTime = (date: Date) => {
      const now = new Date();
      const secondsDiff = differenceInSeconds(now, date);

      if (secondsDiff < 60) {
        return `${secondsDiff} ${secondsDiff === 1 ? "second" : "seconds"} ago`;
      } else if (secondsDiff < 3600) {
        const minutesDiff = differenceInMinutes(now, date);
        return `${minutesDiff} ${minutesDiff === 1 ? "minute" : "minutes"} ago`;
      } else {
        const hoursDiff = differenceInHours(now, date);
        return `${hoursDiff} ${hoursDiff === 1 ? "hour" : "hours"} ago`;
      }
    };

    const formatTimestamp = (date: Date) => {
      if (isToday(date)) {
        return formatRelativeTime(date);
      }
      return format(date, "MMM d, h:mm a");
    };

    const updateFormattedTime = () => {
      setFormattedTime(formatTimestamp(date));
    };

    updateFormattedTime();

    const intervalId = setInterval(() => {
      updateFormattedTime();
    }, 1000);

    return () => clearInterval(intervalId);
  }, [date]);

  return <span className={className}>{formattedTime}</span>;
}
